(function($, Drupal) {
		
	jQuery('.video-component .video-region-wrapper .js-play-video').click(function(){
        jQuery(this).hide();
    })
	
})(jQuery, Drupal);


